/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { amountFont, boldTokenFont } from "../../../config/commonCSS";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { Token } from "../../../store/global/TokenEnum";

export interface WrapAmountLabelProps {
  formattedAmount: string;
  tokenTicker: Token;
}

export const ReviewAmountLabel: React.FC<WrapAmountLabelProps> = props => {
  const theme = GlobalStore.useState(s => s.theme);
  const style = amountFont(theme);
  return (
    <>
      <span css={style} data-sentry-mask="true">
        {props.formattedAmount}{" "}
      </span>
      <span
        css={css`
          ${boldTokenFont(theme)};
          font-family: ${theme.fontFamilies["work-sans"]};
          font-weight: 550;
        `}
      >
        {props.tokenTicker}
      </span>
    </>
  );
};
